import { useState } from "react";

import { useTranslation } from "react-i18next";

import useAxiosPrivate from "../../../../api/hooks/useAxiosPrivate";
import { ApiResources } from "../../../../api/resources";
import { useAuth } from "../../../../context/Auth/AuthProvider";
import { useMediaQueries } from "../../../../shared";
import useResponse from "../../../../shared/hooks/useResponse";
import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "../../../Button/Button";
import Dialog from "../../../Dialog/Dialog";
import { DialogHeight, DialogWidth } from "../../../Dialog/types/enums";
import OptionalTooltip from "../../../Tooltip/OptionalTooltip";
import BetaVersionContent from "./components/BetaVersionContent";

const WelcomeDialog = () => {
  const { user } = useAuth();
  const { putData } = useAxiosPrivate();
  const { handleCommonError } = useResponse();
  const { toMd } = useMediaQueries();
  const { t } = useTranslation();

  const hasUserAcceptedBetaTerms = user?.acceptedBetaTerms;
  const showBetaWellcomeDialog = !hasUserAcceptedBetaTerms;

  const [isOpen, setIsOpen] = useState(showBetaWellcomeDialog);
  const [isChecked, setIsChecked] = useState(hasUserAcceptedBetaTerms);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleCloseDialog = async () => {
    if (isChecked) {
      try {
        setIsLoading(true);

        await putData(ApiResources.AcceptBetaVersionTerms);

        setIsOpen(false);
      } catch (error) {
        handleCommonError(error, t);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      {showBetaWellcomeDialog && (
        <Dialog
          title={t("Dialog##welcome to beta version title")}
          isTitleSeparator
          isActionsSeparator
          close={undefined} // the dialog can be closed only after checking the checkbox on actions button click
          open={isOpen}
          extendToMaxWidth={toMd}
          width={DialogWidth.MaxWidth}
          showXButton={false}
          maxHeight={DialogHeight.MaxHeight}
          actions={
            <OptionalTooltip
              tooltipPlacement="top"
              tooltipTitle={t("General##Tooltip##accept beta terms")}
              isDisabled={isChecked}
            >
              <span>
                <Button
                  fullWidth
                  color={BUTTON_COLORS.Primary}
                  size={BUTTON_SIZES.Normal}
                  variant={BUTTON_VARIANTS.TextOnly}
                  onClick={handleCloseDialog}
                  disabled={!isChecked}
                  isLoading={isLoading}
                >
                  {t("Button##continue to TachoSync")}
                </Button>
              </span>
            </OptionalTooltip>
          }
        >
          <BetaVersionContent onCheckboxChange={toggleCheckbox} />
        </Dialog>
      )}
    </>
  );
};

export default WelcomeDialog;
